import React, { memo } from 'react';

import { numberFormatTypes } from 'constants/fields';

import DataFieldCDS from '../../form/DataFieldCDS';
import TextField from '../../form/TextFieldCDS';
import FormGeneratorFieldWrapperCDS from '../FormGeneratorFieldWrapperCDS';

const FormGeneratorTextFieldCDS = props => {
  const { type, isNumericString } = props;
  const isNumberFormat = numberFormatTypes.includes(type);

  const Component = isNumberFormat || isNumericString ? DataFieldCDS : TextField;

  return <FormGeneratorFieldWrapperCDS FieldComponent={Component} {...props} />;
};

FormGeneratorTextFieldCDS.propTypes = {
  ...FormGeneratorFieldWrapperCDS.propTypes,
  ...TextField.propTypes,
};

export default memo(FormGeneratorTextFieldCDS);
